export class ChartUtils {
    
    static transformMonthEvent(apiData: any[]): any[] {
        if (!apiData) return [];
        
        return apiData.flatMap(yearItem =>
            yearItem.series.map((monthItem: any) => ({
                ...monthItem,
                year: yearItem.year,
                monthYear: `${monthItem.month} ${yearItem.year}`
            }))
        );
    }

    static calculateDynamicMax(values: number[], baseIncrement: number = 5): number {
        const maxValue = Math.max(...values, 0);
        if (maxValue === 0) return baseIncrement;
        return Math.ceil(maxValue / baseIncrement) * baseIncrement;
    }

    static getChartColors(count: number): string[] {
        const baseColors = [
            '#50B748', '#2CC3E8', '#FF6B6B', '#FFD93D', '#6BCF7F',
            '#4ECDC4', '#FF8A5B', '#9B5DE5', '#00BBF9', '#F15BB5',
            '#00F5D4', '#FF9E00', '#7209B7', '#3A86FF', '#FB5607',
            '#8338EC', '#FF006E', '#FB5607', '#FFBE0B', '#3A86FF',
            '#00F5D4', '#06D6A0', '#118AB2', '#073B4C', '#EF476F'
        ];
        return baseColors.slice(0, count);
    }
}